module.exports = __webpack_public_path__ + "img/guifan2.c40f804f.jpg";